export default "__VITE_ASSET__c6f1ecb1__"